const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-admin-bg">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-admin-accent"></div>
        <p className="mt-4 text-admin-textLight">読み込み中...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
